module.exports = __webpack_public_path__ + "img/ico-send-black.e37e0d61.svg";